<template>
    <div>
        <hts-cooperator-type :types="type" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const type = computed(() => params?.value?.data.type)
</script>
